module.exports = "/_next/static/images/paypal-76f8ecb76a005f67cc921196a5bbdefa.png";